var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"loading"}},[(_vm.loadingStatus)?_c('div',{staticClass:"loading-progress-bar",class:{loaded: _vm.loadedStatus}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }